// ===============================================================
//
// Page forCAD topology
//
// Function: Upload CAD topology json files
//
// Push CAD topology file to AWS
// The json data to be uploaded will contain :
//    1. Tag name
//    2. Group name and ID - to push to AWS
//    3. ami id and other details
//    4. instance type
// Additional functions : Delete uploaded topology files
//
//
//
//
//
// ===============================================================

import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import { Link } from 'react-router-dom';
import { Dropdown, ButtonGroup } from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb'
// import { combineReducers } from "redux";
import {
  sendConfigDataToDatabase,
  ReadCADCloudTopology,
  saveUploadedCadTopology,
  getDataFromDatabaseForCadTopology,
  setUserIdInDb,
  resetAllQueuesFromAWSForCadTopology,
  GetAwsQueuesFromConfig,
  killAndTerminateAllInstances,
  downloadCADTopology,
  downloadReportFiles,
  downloadLogFiles
} from "../UserFunctions";
import DeleteJsonDataModal from "./DeleteJsonDataModal";

const CadTopology = (props) => {
  const [jsonfile, setJsonfile] = useState([]);
  const [dbdata, setdbdata] = useState([]);
  const hiddenFileInput = useRef(null);
  const startHidden = useRef(false);
  const stopHidden = useRef(false);
  const [showRowActions, setShowRowActions] = useState(undefined);
  const [deleteSelectedRow, setDeleteSelectedRow] = useState(undefined);
  const [popUpFlag, setPopUpFlag] = useState(false);
  const [value, setvalue] = useState("");
  const [user, setuser] = useState("");
  const [cadTopologyId, setcadTopologyId] = useState("");
  const [startPopUpFlag, setStartPopUpFlag] = useState(false);
  const [deleteJobUuid, setdeleteJobUuid] = useState(0);
  const [pushPopUpOpen, setpushPopUpOpen] = useState(false);
  const [stopPopUpOpen, setstopPopUpOpen] = useState(false);
  const [pushStatusPopUp, setpushStatusPopUp] = useState(false);
  const [startIndex, setstartIndex] = useState(0);
  const [stopIndex, setstopIndex] = useState(0);
  const [awsQueues, setawsQueues] = useState([]);
  const [buttonPushPopUp, setbuttonPushPopUp] = useState(false);
  const [buttonKillOrResetQ, setbuttonKillOrResetQ] = useState(0);
  const [submitDisabled, setsubmitDisabled] = useState(false);

  useEffect(() => {
    getDataFromDatabaseForCadTopology("get_data_from_db_for_cad_topology").then(
      (response) => {
        setdbdata(response.data.data);
      }
    );
  }, []);
  // Function called when file is uploaded
  const handleJsonUpload = (event) => {
    if (event.target.files[0] !== undefined) {
      let filereader = new FileReader();
      filereader.addEventListener(
        "load",
        function () {
          if (this.result) {
            const payload = {
              json_file_data: JSON.parse(this.result),
              description: value,
            };
            setJsonfile(JSON.parse(this.result));
            console.log("cad data", JSON.parse(this.result))
            console.log("ami id data", JSON.parse(this.result)[0]["instance_details"]["ami_id"])
            sendConfigDataToDatabase("/save_cad_data", payload).then(
              (response) => {
                console.log(response.data.message);
                // Retrieve data from database
                getDataFromDatabaseForCadTopology(
                  "get_data_from_db_for_cad_topology"
                ).then((response) => {
                  setdbdata(response.data.data);
                });
                console.log("data[0]", response.data.message[0]["job_id"]);
                setcadTopologyId(response.data.message[0]["job_id"])

                //Uploading new data into CAD topology database
                const payload = {
                  file_content: JSON.parse(this.result),
                  json_name: response.data.message[0]["job_id"],
                };
                saveUploadedCadTopology("/upload_topology_json", payload);
              }
            );
          }
        },
        false
      );
      filereader.readAsText(event.target.files[0]);
    }
    closeModal();
  };

  const onValueChange = (e) => {
    console.log(e.target.value);
    setvalue(e.target.value);
  };

  const onUserIdValueChange = (e) => {
    console.log("-------------------------------->", e.target.value);
    let textValid = e.target.value ? true : false;
    setuser(e.target.value);
    setsubmitDisabled(textValid)
  };

  // Function when start button is pressed -> push data to AWS
  const handleStart = (e) => {
    setsubmitDisabled(false)
    console.log("cad job id", dbdata[startIndex]["job_id"])
    console.log("cadTopologyId", cadTopologyId);
    console.log(user)
    let cad_topology_id_execution = ''
    if (cadTopologyId) {
      cad_topology_id_execution = cadTopologyId
    }
    else {
      cad_topology_id_execution = dbdata[startIndex]["job_id"]
    }
    console.log("real cad", cad_topology_id_execution)
    const user_payload = {
      cad_topology_id: cad_topology_id_execution,
      user: user,
    };
    setUserIdInDb("update_id", user_payload);

    console.log(startPopUpFlag)
    e.preventDefault();
    setStartPopUpFlag(true);

    // Send data to database
    const payload = {
      job_uuid: dbdata[startIndex]["job_id"],
    };
    sendConfigDataToDatabase(
      `${window.location.origin}/update_cad_data`,
      payload
    ).then((response) => {
      setdbdata(response.data.data);
    });
    // Reading and submiting topology data
    ReadCADCloudTopology(
      `${window.location.origin}/submit_cad_cloud_topology`,
      payload
    ).then((response) => {
      console.log(response.status);
      if (response.status === 200) {
        setpushStatusPopUp(true);
      }
    });
  };
  // When refresh button is clicked
  const handleRefresh = () => {
    getDataFromDatabaseForCadTopology("get_data_from_db_for_cad_topology").then(
      (response) => {
        setdbdata(response.data.data);
      }
    );
  };

  const handleOpenKillandReset = () => {
    setbuttonPushPopUp(true);
    setbuttonKillOrResetQ(1);
  };

  const handleStopKillandReset = () => {
    setbuttonPushPopUp(true);
    setbuttonKillOrResetQ(1);
    // setstopPopUpOpen(false);
  };

  // Function called when either kill and terminate queues button or
  // reset queues button is pressed
  const handleCloseKillandReset = () => {
    setbuttonPushPopUp(false);
    setbuttonKillOrResetQ(0);
    setbuttonPushPopUp(false);
    setbuttonKillOrResetQ(0);
    setstopPopUpOpen(false);
  };

  const handleKillandReset = () => {
    killAndTerminateAllInstances(
      "/aws/ec2/kill_and_terminate_all_instances_by_force"
    );
    handleReset();
  };
  const handleOpenResetQueues = () => {
    setbuttonPushPopUp(true);
    setbuttonKillOrResetQ(2);
  };

  const handleReset = () => {
    GetAwsQueuesFromConfig("/get_aws_queues").then((response) => {
      console.log(awsQueues)
      setawsQueues(response.data.queues);
      for (var i = 0; i < response.data.queues.length; i++) {
        var payload = {
          queue_name: response.data.queues[i],
        };
        resetAllQueuesFromAWSForCadTopology(
          "/aws/sqs/remove_messages",
          payload
        );
      }
    });
    handleCloseKillandReset();
  };

  //
  // For start button popup
  //
  const handleStartPopUpOpen = (index_val) => {
    setpushPopUpOpen(true);
    setstartIndex(index_val["index"]);
  };

  const handleStopPopUpOpen = (index_val) => {
    setstopPopUpOpen(true);
    setstopIndex(index_val["index"]);
  }
  //
  // Close start popup
  //
  const handleStartPopUpClose = () => {
    setpushPopUpOpen(false);
  };

  const handleStopPopUpClose = () => {
    console.log(stopIndex)
    setstopPopUpOpen(false);
  };
  //
  // Push button after start
  //
  const pushStatusPopUpClose = () => {
    setpushStatusPopUp(false);
    setpushPopUpOpen(false);
  };
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const handleClickGetStatus = (key) => {
    localStorage.setItem("cad_uuid", key);
    window.open("/cad_test_run_status", "_blank");
  };

  const handleDelete = (e, index_val) => {
    e.preventDefault();
    const index = index_val["index"];
    console.log(index);
    const job_uuid_del = dbdata[index]["job_id"];
    setdeleteJobUuid(job_uuid_del);
    console.log("Job UUID : ", deleteJobUuid);
    setShowRowActions(index);
  };
  //
  // Closing popup
  //
  const handleCloseDialogModal = () => {
    setShowRowActions(undefined);
  };
  //
  // delete popup
  //
  const handleOpenDeleteModal = () => {
    setDeleteSelectedRow(showRowActions);
    setShowRowActions(undefined);
    console.log("dbdata in cadtopo:", dbdata);
  };
  //
  // close delete popup
  //
  const handleCloseDeleteModal = () => {
    setDeleteSelectedRow(undefined);
  };
  //
  // Dowload button clicked
  //
  // const handleDownload = ( index_val) => {
  //   let job_id = dbdata[index_val.index]["job_id"];
  //   let file_path = "./CAD_topology/" + job_id + ".json";
  //   fetch(file_path)
  //     .then((res) => res.json())
  //     .then((data) => {
  //       let filename = "CAD_topology_" + job_id + ".json";
  //       let contentType = "application/json;charset=utf-8;";
  //       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //         var blob = new Blob(
  //           [decodeURIComponent(encodeURI(JSON.stringify(data)))],
  //           { type: contentType }
  //         );
  //         navigator.msSaveOrOpenBlob(blob, filename);
  //       } else {
  //         var a = document.createElement("a");
  //         a.download = filename;
  //         a.href =
  //           "data:" +
  //           contentType +
  //           "," +
  //           encodeURIComponent(JSON.stringify(data));
  //         a.target = "_blank";
  //         document.body.appendChild(a);
  //         a.click();
  //         document.body.removeChild(a);
  //       }
  //     });
  // };

  const handleDownload = ( index_val) => {
    let job_id = dbdata[index_val.index]["job_id"];
    const payload = {
      "cad_topology_job_uuid": job_id
    }
    downloadCADTopology("/cad_topology_download", payload).then(
      (response) => {
        if(response && response.status === 200) {
          const fileName = "CAD_topology_" + job_id + ".json";
          const json = JSON.stringify(response.data, null, 2);
          const url = window.URL.createObjectURL(new Blob([json], { type: "application/json" }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',fileName);
          document.body.appendChild(link);
          link.click();
          console.log(response.data)
        }
      }
    );
  };

  const handleReportDownload = (index_val) => {
    let job_id = dbdata[index_val.index]["job_id"];
    const payload = {
      "cad_topology_job_uuid": job_id
    }
    downloadReportFiles("/fetch_report", payload).then(
      (response) => {
        if (response && response.status === 200) {
          // const fileName = response.headers["content-disposition"].split("filename=")[1];
          const url = window.URL.createObjectURL(
            new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',
            response.headers["content-disposition"].split("filename=")[1]);
          document.body.appendChild(link);
          link.click();
        }
      }
    );
  };

  const handleLogsDownload = (index_val) => {
    let job_id = dbdata[index_val.index]["job_id"];
    const payload = {
      "cad_topology_uuid": job_id
    }
    downloadLogFiles("/log_files/download", payload).then(
      (response) => {
        if (response && response.status === 200) {
          // const fileName = response.headers["content-disposition"].split("filename=")[1];
          const url = window.URL.createObjectURL(
            new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',
            response.headers["content-disposition"].split("filename=")[1]);
          document.body.appendChild(link);
          link.click();
        }
      }
    );
  };
  // const handleDownload = (e, index_val) => {
  //   let job_id = dbdata[index_val.index]['job_id']
  //   let file_path = "./CAD_topology/"+job_id+".json"
  //   fetch(file_path)
  //   .then((res) => res.json())
  //   .then((data) => {
  //       let filename = "CAD_topology_"+job_id+".json";
  //       let contentType = "application/json;charset=utf-8;";
  //       if (window.navigator && window.navigator.msSaveOrOpenBlob) {
  //         var blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(data)))], { type: contentType });
  //         navigator.msSaveOrOpenBlob(blob, filename);
  //       } else {
  //         var a = document.createElement('a');
  //         a.download = filename;
  //         a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(data));
  //         a.target = '_blank';
  //         document.body.appendChild(a);
  //         a.click();
  //         document.body.removeChild(a);
  //       }
  // })

  // };

  const openModal = () => {
    setPopUpFlag(true);
  };
  const closeModal = () => {
    setPopUpFlag(false);
    setvalue("");
  };

  return (
    //
    // Return function
    //
    <div
      data-test="cadCloudTopoplogyCadTopologyComponent"
      className="container-fluid"
    >
      <Breadcrumb>
        <Breadcrumb.Item href="">
          <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
        <Breadcrumb.Item href="">
          <Link to='/welcome'>Welcome</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href=""  >
          <Link to='/close_loop'>Close loop</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item href="/CadTopology" active >
          CAD Cloud Topology Manager
        </Breadcrumb.Item>
      </Breadcrumb>
      <div className="row" style={{ paddingTop: "5%" }}>
        <div style={{ margin: "auto" }}>
          {/* <h1 style={{color:"#464646"}}></h1> */}
        </div>
      </div>
      <div className="col mt-5 mx-auto">
        <div className="card" style={{ backgroundColor: "white" }}>
          <div className="card-header" style={{ backgroundColor: "#757AF7" }}>
            <div className="row align-items-center">
              <div className="col-md-7">
                <h1 style={{ color: "white", fontSize: "100% !important" }}>
                  CAD Cloud Topology Manager
                </h1>
              </div>
              <div className="col-md-5">
                <Button
                  className="btn btn-light"
                  onClick={handleOpenKillandReset}
                  style={{
                    marginRight: "0.1rem",
                    border: "0px",
                    color: "#753DFF",
                  }}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Reset all Queues and Kill all Instances"
                >
                  <i className="fa fa-broom"></i>
                </Button>
                <Button
                  className="btn btn-light"
                  onClick={handleRefresh}
                  style={{
                    marginRight: "0.1rem",
                    border: "0px",
                    color: "#753DFF",
                  }}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Update"
                >
                  <i className="fa fa-undo"></i>
                </Button>
                <Button
                  className="btn btn-light"
                  onClick={handleOpenResetQueues}
                  style={{
                    marginRight: "0.1rem",
                    border: "0px",
                    color: "#753DFF",
                  }}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Reset All Queues"
                >
                  {" "}
                  Reset All Queues
                </Button>
                <Button
                  className="btn btn-light"
                  onClick={openModal}
                  style={{
                    marginRight: "0.1rem",
                    border: "0px",
                    color: "#753DFF",
                  }}
                >
                  Upload CAD Topology
                </Button>
                {/* <Button
                  className="btn btn-light"
                  onClick={handleReset}
                  style={{
                    marginRight: "0.1rem",
                    border: "0px",
                    color: "#753DFF"}}
                    data-toggle="tooltip" data-placement="top" title="Reset All Queues"> Reset All Queues</Button>
                    <Button
                    className="btn btn-light"
                    onClick={openModal}
                    style={{
                      marginRight: "0.1rem",
                      border: "0px",
                      color: "#753DFF",}}>Upload CAD Topology</Button> */}
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleJsonUpload}
                  id="uploadedjson"
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            <table className="table">
              <thead
                className="table-heads"
                style={{
                  borderBottom: "4px solid #622AD8",
                  textAlign: "center",
                }}
              >
                <tr>
                  <th scope="col" key="Job ID" style={{ textAlign: "center" }}>
                    Topology ID
                  </th>
                  <th
                    scope="col"
                    key="Description"
                    style={{ width: "20%", textAlign: "center" }}
                  >
                    Description
                  </th>
                  <th
                    scope="col"
                    key="Start Date"
                    style={{ textAlign: "center" }}
                  >
                    Start Date
                  </th>
                  <th
                    scope="col"
                    key="End Date"
                    style={{ textAlign: "center" }}
                  >
                    End Date
                  </th>
                  {/* <th scope="col" key="Status" style={{ textAlign: "center" }}>Status</th> */}
                  <th
                    scope="col"
                    key="Actions"
                    style={{ width: "20%", textAlign: "center" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="table-row">
                {dbdata.map((postdetail, index) => {
                  if (postdetail.status === "Not Started") {
                    startHidden.current = false;
                    stopHidden.current = false;
                  } else if (postdetail.status === "Running") {
                    startHidden.current = true;
                    stopHidden.current = true;
                  } else {
                    startHidden.current = true;
                    stopHidden.current = true;
                  }
                  return (
                    <tr className="table-row" key={index}>
                      <td key={`Job ID_${index}`}>
                        {" "}
                        <li
                          onClick={() => {
                            handleClickGetStatus(postdetail.job_id);
                          }}
                        >
                          {" "}
                          {postdetail.job_id}
                        </li>
                      </td>
                      <Link to={{
                            pathname: "/close_loop/pre-validation/configuration",
                            state: { cadTopologyId: postdetail['job_id'] }
                        }}
                        style={{ textDecoration: "none" }}>
                        <td
                          key={`Description_${index}`}
                        >
                          {postdetail.description}{" "}
                        </td>
                      </Link>
                      <td key={`Start Date_${index}`}>
                        {postdetail.start_date}
                      </td>
                      <td key={`End Date_${index}`}>{postdetail.end_date}</td>
                      {/* <td key={`Status_${index}`}>{postdetail.status}</td> */}
                      <td key={`Actions_${index}`}>
                        <button
                          className="btn"
                          style={{ marginRight: "1%" }}
                          key={`StatusStart_${index}`}
                          onClick={() => handleStartPopUpOpen({ index })}
                          hidden={startHidden.current}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Start"
                        >
                          <i className="fas fa-play-circle"></i>
                        </button>
                        <button
                          className="btn"
                          style={{ marginRight: "1%" }}
                          key={`StatusStop_${index}`}
                          onClick={() => handleStopPopUpOpen({ index })}
                          hidden={stopHidden.current}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Stop"
                        >
                          <i className="fas fa-stop-circle"></i>
                        </button>
                        <button
                          className="btn"
                          key={`Delete_${index}`}
                          style={{ marginRight: "1%", marginLeft: "1%" }}
                          onClick={(e) => handleDelete(e, { index })}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                        <ButtonGroup>
                          <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">
                              <i className="fas fa-download"></i>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => handleDownload({ index })}
                              >
                                CAD Topology JSON
                              </Dropdown.Item>
                              <Dropdown.Divider />
                              <Dropdown.Item
                                onClick={() => handleReportDownload({ index })}
                              >
                                Download Report Files
                              </Dropdown.Item>
                              <Dropdown.Divider />
                              <Dropdown.Item
                                onClick={() => handleLogsDownload({ index })}
                              >
                                Download Log Files
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {showRowActions !== undefined && showRowActions >= 0 ? (
            //
            // If upload button is pressed
            //
            <Modal isOpen={showRowActions >= 0}>
              <ModalHeader
                toggle={handleCloseDialogModal}
                style={{ color: "#753DFF" }}
              >
                Choose Actions
              </ModalHeader>
              <ModalBody>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-sm-12">
                        <Button
                          className="btn"
                          style={{ width: "100%" }}
                          onClick={handleOpenDeleteModal}
                        >
                          Delete
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="btn btn-secondary"
                  style={{ marginRight: "40%" }}
                  onClick={handleCloseDialogModal}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
          {deleteSelectedRow >= 0 ? (
            <DeleteJsonDataModal
              deleteSelectedRow={deleteSelectedRow}
              handleCloseDeleteModal={handleCloseDeleteModal}
              jsonfile={dbdata}
              setJsonfile={setdbdata}
              deleteJobUuid={deleteJobUuid}
              useHistory={props}
              description={dbdata[deleteSelectedRow]["description"]}
              deleteContent={jsonfile[parseInt(deleteSelectedRow)]}
            />
          ) : undefined}

          {popUpFlag ? (
            //
            // If upload button is pressed
            //
            <Modal isOpen={true}>
              <ModalHeader
                toggle={closeModal}
                style={{ backgroundColor: "#753DFF" }}
              >
                Upload Topology
              </ModalHeader>
              <ModalBody>
                <form>
                  <div className="form-group">
                    Description:
                    <input
                      type="text"
                      className="form-control"
                      name="value"
                      placeholder="Add Description"
                      value={value}
                      onChange={(e) => {
                        onValueChange(e);
                      }}
                    />
                    <br></br>
                    <Button
                      className="btn btn-light"
                      onClick={handleClick}
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: "#753DFF",
                        width: "100%",
                      }}
                    >
                      Upload Json
                    </Button>
                    <br />
                    <br />
                    <input
                      type="file"
                      ref={hiddenFileInput}
                      onChange={handleJsonUpload}
                      id="uploadedjson"
                      style={{ display: "none" }}
                    />
                  </div>
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="btn"
                  style={{ backgroundColor: "#753DFF" }}
                  onClick={closeModal}
                >
                  Close
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
          {pushPopUpOpen ? (
            //
            // If push popup is pressed
            //
            <Modal isOpen={true}>
              <ModalHeader
                toggle={handleStartPopUpClose}
                style={{ backgroundColor: "#753DFF" }}
              ></ModalHeader>
              <ModalBody>
                Do you want to push Topology into the queue?
                <div>
                  User ID:
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Add User ID"
                    onChange={(e) => {
                      onUserIdValueChange(e);
                    }}
                  />
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  className="btn"
                  style={{ marginLeft: "70%" }}
                  disabled={!submitDisabled}
                  onClick={(e) => {
                    handleStart(e);
                  }}

                >
                  Yes
                </Button>
                <Button
                  className="btn"
                  style={{ marginRight: "40%", backgroundColor: "red" }}
                  onClick={handleStartPopUpClose}
                >
                  No
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
          {stopPopUpOpen ? (
            //
            // If stop popup is pressed
            //
            <Modal isOpen={true}>
              <ModalHeader
                toggle={handleStopPopUpClose}
                style={{ backgroundColor: "#753DFF" }}
              ></ModalHeader>
              <ModalBody>
                Do you want to stop current execution?
              </ModalBody>
              <ModalFooter>
                <Button
                  className="btn"
                  style={{ marginLeft: "70%" }}
                  onClick={handleStopKillandReset}
                >
                  Yes
                </Button>
                <Button
                  className="btn"
                  style={{ marginRight: "40%", backgroundColor: "red" }}
                  onClick={handleStopPopUpClose}
                >
                  No
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
          {pushStatusPopUp ? (
            //
            // If push popup ok is pressed
            //
            <Modal isOpen={true}>
              <ModalHeader
                toggle={pushStatusPopUpClose}
                style={{ backgroundColor: "#753DFF" }}
              ></ModalHeader>
              <ModalBody>Topology has been pushed into queue.</ModalBody>
              <ModalFooter>
                <Button className="btn" onClick={pushStatusPopUpClose}>
                  Ok
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
          {buttonPushPopUp ? (
            <Modal isOpen={true}>
              <ModalHeader
                toggle={handleCloseKillandReset}
                style={{ backgroundColor: "#753DFF" }}
              ></ModalHeader>
              <ModalBody>
                {buttonKillOrResetQ === 1 ? (
                  <p>
                    Do you want to kill and terminate all instances and reset
                    queues
                  </p>
                ) : (
                  <p>Do you want to reset all queues ?</p>
                )}
              </ModalBody>
              <ModalFooter>
                {buttonKillOrResetQ === 1 ? (
                  <Button
                    className="btn"
                    style={{ marginLeft: "70%" }}
                    onClick={handleKillandReset}
                  >
                    Yes
                  </Button>
                ) : (
                  <Button
                    className="btn"
                    style={{ marginLeft: "70%" }}
                    onClick={handleReset}
                  >
                    Yes
                  </Button>
                )}
                <Button
                  className="btn"
                  style={{ marginRight: "40%", backgroundColor: "red" }}
                  onClick={handleCloseKillandReset}
                >
                  No
                </Button>
              </ModalFooter>
            </Modal>
          ) : undefined}
        </div>
      </div>
    </div>

    // End of return function
    //
  );
};

export default CadTopology;
